'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { Fragment, useState } from 'react';
import styled from 'styled-components';
import partial from 'transmute/partial';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import breakpoint from '../../utils/responsiveBreakpoints';
import StickyContainer from '../common/StickyContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OLAF } from 'HubStyleTokens/colors';
import { tabsNavigateTo } from 'pricing-pages-lib/utils/urls';
const MobileMenuCategory = styled.span.withConfig({
  displayName: "MobileTabs__MobileMenuCategory",
  componentId: "sc-1rm14do-0"
})(["font-weight:800;display:block;position:relative;overflow:hidden;font-size:0.85em;opacity:0.7;margin-top:1.37em;margin-bottom:0.15em;&:first-child{margin-top:0;}&::after{content:'';display:inline-block;background-color:", ";height:1px;position:absolute;top:50%;transform:translate(10px,-50%);width:100%;}"], OLAF);
const MobileMenuBody = styled(UIDialogBody).withConfig({
  displayName: "MobileTabs__MobileMenuBody",
  componentId: "sc-1rm14do-1"
})(["background-color:#167186;background-image:linear-gradient(to top right,#167186,#167d7a);color:", ";&.pricing-mobile-menu-body{padding:3.4em 1.45em;}"], OLAF);
const MobileMenuBodyInner = styled.div.withConfig({
  displayName: "MobileTabs__MobileMenuBodyInner",
  componentId: "sc-1rm14do-2"
})(["display:flex;flex-direction:column;padding:40px 0;"]);
const MobileMenuLinkWrapper = styled.div.withConfig({
  displayName: "MobileTabs__MobileMenuLinkWrapper",
  componentId: "sc-1rm14do-3"
})(["position:relative;display:flex;margin:0 auto 1.57em 0;align-items:center;cursor:pointer;"]);
const MobileMenuLink = styled(FormattedMessage).withConfig({
  displayName: "MobileTabs__MobileMenuLink",
  componentId: "sc-1rm14do-4"
})(["display:inline-block;font-size:1.57em;line-height:1.4;&[selected='true']{text-decoration:underline;}"]);
const MobileMenuCloseButton = styled(UIDialogCloseButton).withConfig({
  displayName: "MobileTabs__MobileMenuCloseButton",
  componentId: "sc-1rm14do-5"
})(["transform:scale(0.6);right:34px;top:13px;"]);
const MobileMenuTriggers = styled(StickyContainer).withConfig({
  displayName: "MobileTabs__MobileMenuTriggers",
  componentId: "sc-1rm14do-6"
})(["display:none;text-align:center;width:100%;cursor:pointer;background-color:#167186;background-image:linear-gradient(to top right,#167186,#167d7a);color:", ";font-size:1.6em;font-weight:100;padding:0.6em 0.7em 0.86em 0.7em;", ""], OLAF, breakpoint.tablet(_t || (_t = _`
    display: block;
  `)));
const MobileMenuTriggerLink = styled(FormattedMessage).withConfig({
  displayName: "MobileTabs__MobileMenuTriggerLink",
  componentId: "sc-1rm14do-7"
})(["display:block;"]);
const MobileMenuTriggerCategory = styled(FormattedMessage).withConfig({
  displayName: "MobileTabs__MobileMenuTriggerCategory",
  componentId: "sc-1rm14do-8"
})(["font-size:0.515em;letter-spacing:0.5px;margin-bottom:0.515em;opacity:0.7;font-weight:600;"]);
const MobileMenuTriggerIcon = styled(UIIcon).withConfig({
  displayName: "MobileTabs__MobileMenuTriggerIcon",
  componentId: "sc-1rm14do-9"
})(["transform:scale(0.45) translateY(-50%);position:absolute;right:0.06em;margin:0;top:50%;color:", ";"], OLAF);

const MobileTabs = ({
  selectedPrimaryTab,
  selectedSecondaryTab,
  isHSFXEligible,
  history,
  tabConfig
}) => {
  const [isModalVisible, setModalVisibility] = useState(false);

  const toggleModal = isVisible => setModalVisibility(isVisible);

  const selectedConfig = tabConfig[selectedPrimaryTab].children.find(tab => tab.id === selectedSecondaryTab);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(MobileMenuTriggers, {
      onClick: partial(toggleModal, true),
      className: "mobile-menu-tab-triggers",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(MobileMenuTriggerCategory, {
          message: selectedConfig.mobileCategory
        }), /*#__PURE__*/_jsx(MobileMenuTriggerLink, {
          message: selectedConfig.mobileKey,
          onClick: partial(toggleModal, true)
        })]
      }), /*#__PURE__*/_jsx(MobileMenuTriggerIcon, {
        name: "down",
        size: "sm",
        color: OLAF
      })]
    }), isModalVisible && /*#__PURE__*/_jsxs(UIModal, {
      children: [/*#__PURE__*/_jsx(MobileMenuCloseButton, {
        onClick: partial(toggleModal, false),
        size: "xl"
      }), /*#__PURE__*/_jsx(MobileMenuBody, {
        className: "pricing-mobile-menu-body",
        children: /*#__PURE__*/_jsx(MobileMenuBodyInner, {
          children: Object.keys(tabConfig).map(tabKey => {
            const {
              getTitle,
              children
            } = tabConfig[tabKey];
            return /*#__PURE__*/_jsxs(Fragment, {
              children: [/*#__PURE__*/_jsx(MobileMenuCategory, {
                children: getTitle()
              }), children.map(childTab => /*#__PURE__*/_jsxs(MobileMenuLinkWrapper, {
                onClick: partial(tabsNavigateTo, {
                  path: `/${childTab.slug || childTab.id}`,
                  history
                }),
                children: [/*#__PURE__*/_jsx(MobileMenuLink, {
                  selected: selectedSecondaryTab === childTab.id,
                  message: childTab.mobileKey
                }), childTab.mobileBadge && childTab.mobileBadge({
                  isHSFXEligible
                })]
              }, childTab.id))]
            }, tabKey);
          })
        })
      })]
    })]
  });
};

export default MobileTabs;